import CustomLink from '@/shared/components/customLink'
import MyImage from '@/shared/components/myImage'
import { RightArrow } from '@/shared/Icons'
import { getImgURL } from '@/shared/utils'
import React from 'react'

interface MatchDetail {
  matchDetail: {
    sSubtitle: string
    oSeries: {
      sTitle: string
      oSeo: {
        sSlug: string
      }
      oCategory: {
        oImg: {
          sUrl: string
        }
        oSeo: {
          sSlug: string
        }
      }
    }
  }
}

function SeriesTitle({ matchDetail }: MatchDetail) {
  return (
    <div className="flex justify-between items-center pb-4 sm:pb-6 mb-4 sm:mb-6 border-borderStroke border-b">
      <div>
        <p className="mb-1 sm:mb-2 text-textDselected text-xs sm:text-base">
          {matchDetail?.sSubtitle}
        </p>
        <CustomLink
          href={`/${matchDetail?.oSeries?.oCategory?.oSeo?.sSlug}`}
          className="flex items-center gap-1 font-bold text-textOffWhite text-sm sm:text-base"
        >
          {matchDetail?.oSeries?.sTitle}{' '}
          <span className="block h-4 w-4">
            <RightArrow />
          </span>
        </CustomLink>
      </div>
      {matchDetail?.oSeries?.oCategory?.oImg?.sUrl && (
        <MyImage
          src={getImgURL(matchDetail?.oSeries?.oCategory?.oImg?.sUrl)}
          alt="ICC"
          width={60}
          height={68}
          className=" rounded-lg aspect-auto object-cover"
        />
      )}
    </div>
  )
}

export default SeriesTitle
